import React from "react";
import { AiOutlineMail } from "react-icons/ai";
import { FaDiscord } from "react-icons/fa";
import "balloon-css";

export function About(props: { view: string }) {
  return (
    <div id="about" className={"about" + props.view}>
      <div>
        <div className="about-text-title">Hello there, I'm Serge👋</div>
        <br />

        <div>
          I'm a Computer Science student at the University of King's College
          London.
        </div>
        <br />

        <div
          style={{
            fontSize: "1.1rem",
          }}
        >
          I am also a dynamic and results-driven Computer Science professional.
          My experience spans developing innovative AI solutions, designing
          simulations to study complex systems, and collaborating on projects
          that demand seamless functionality.
        </div>
        {/* Fluent in both Arabic and English, I bring a global perspective to my work */}

        <br />
        <div className="about-contact">
          <div className="about-contact-button">
            <a
              target="_blank"
              aria-label="syraj.alkhalil7@gmail.com"
              data-balloon-pos="down"
              style={{
                backgroundColor: "#757c8b",
              }}
              className="about-contract-links"
              href="mailto: syraj.alkhalil7@gmail.com"
            >
              <AiOutlineMail
                style={{ color: "black" }}
                className="contact-icon"
              />
              <p>Email</p>
            </a>
          </div>
          <div className="about-contact-button">
            <a
              target="_blank"
              aria-label="スパゲティ先輩👾#5607"
              data-balloon-pos="down"
              style={{
                backgroundColor: "rgb(114, 137, 218)",
              }}
              className="about-contract-links"
              href="https://discord.com/users/548197854720688129"
            >
              <FaDiscord className="contact-icon" />
              <p>Discord</p>
            </a>
          </div>
        </div>
      </div>

      <img
        className="about-img"
        src="imgs/programmer.webm"
        alt="programmer gif"
      />
    </div>
  );
}
